<template>
  <div class="dropdown-items" :class="{ active: isActive }">
    <div @click="$emit('clickFav')">
      <i v-if="!isFav" class="bx bx-star cursor-pointer bx-sm ml-1 mr-2 text-warning"></i>
      <i v-else class="bx bxs-star cursor-pointer bx-sm ml-1 mr-2 text-warning"></i>
    </div>
    <div class="item-container" @click="handleClick">
      <div class="item-icon">
        <i :class="icon" class="bx-sm text-primary"></i>
      </div>
      <div class="item-contentt">
        <div class="title">{{ title }}</div>
        <div class="desc">{{ description }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'dropdown-item',

  props: {
    icon: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    isFav: {
      type: Boolean,
      default: false,
    },
    isActive: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    handleClick() {
      this.$emit('click')
    },
  },
}
</script>

<style scoped></style>
